import React, { Dispatch, SetStateAction, useContext, useEffect, useState } from 'react';
import InsightFiltersViewModel from '../../ViewModels/InsightFiltersViewModel';
import SelectFilterContainer from '../GenericFilters/Select/SelectFilterContainer';
import { APIContext } from '../../../Contexts/APIContext';
import { InsightView } from '../../../ViewModels/InsightView';

interface IWeekNumberFilterContainerProps {
    view: InsightView;
    filters: InsightFiltersViewModel;
    setFilters: Dispatch<SetStateAction<InsightFiltersViewModel>>;
}

export default function WeekNumberFilterContainer({ view, filters, setFilters }: IWeekNumberFilterContainerProps) {
    const { get } = useContext(APIContext);
    const [weekNumbers, setWeekNumbers] = useState<string[]>([]);

    useEffect(() => {
        let controllerAction: string;
        switch (view) {
            case InsightView.Agent:
                controllerAction = 'GetAgentReportWeekNumbers';
                break;
            case InsightView.Operational:
                controllerAction = 'GetOperationalReportWeekNumbers';
                break;
            default:
                throw new Error(`WeekNumberFilterContainer does not support the ${view} InsightView`);
        }
        get('Insight', `${controllerAction}?client=${filters.client}`, (data) => setWeekNumbers(data));
    }, [view, filters.client]);

    return (
        <SelectFilterContainer
            filters={filters}
            setFilters={setFilters}
            name={'weekNumber'}
            label={'Week Number'}
            options={weekNumbers}
        />
    );
}